import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})

export class AdminService {

  private logger = new Subject<boolean>();
  private admin = new Subject<boolean>();
  public loggedIn: boolean = false;

  constructor(private http: HttpClient, private router: Router) { }

  public isLoggedIn(): Observable<boolean> {
    return this.logger.asObservable();
  }


  public createConversation(recipientId: number): Observable<any> {
    return this.http.post(`${BASEURL}/conversations.json`, {
      recipient_id: recipientId
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((respose: any) => {

      })
    )
  }

  public getConversations(): Observable<any> {
    return this.http.get(`${BASEURL}/conversations.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public getConversation(uid: number): Observable<any> {
    return this.http.get(`${BASEURL}/conversations/${uid}.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public sendMessage(userId: number, conversationId: number, body: string) {
    return this.http.post(`${BASEURL}/messages.json`, {
      user_id: userId,
      body,
      conversation_id: conversationId,
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((respose: any) => {

      })
    )
  }

  public getCoaches(): Observable<any> {
    return this.http.get(`${BASEURL}/admin/coaches.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public updateCoach(userId: number, coachId: number) {
    return this.http.put(`${BASEURL}/admin/clients/${userId}/update_coach.json`, {
      user: {
        coach_id: coachId
      },
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((respose: any) => {

      })
    )
  }

  public updateManager(userId: number, coachId: number) {
    return this.http.put(`${BASEURL}/admin/clients/${userId}/update_manager`, {
      user: {
        coach_id: coachId
      },
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((respose: any) => {

      })
    )
  }

  public deleteManager(userId: number) {
    return this.http.delete(`${BASEURL}/admin/clients/${userId}/update_manager`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((respose: any) => {

      })
    )
  }

  public getAnalytics(): Observable<any> {
    return this.http.get(`${BASEURL}/admin/analytics/ages.json`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public getReferrals(userId: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/users/${userId}/referrals`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public getRedemptions(userId: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/users/${userId}/redemptions`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public markAsRedeemed(referralId: string): Observable<any> {
    return this.http.put(`${BASEURL}/v3/referrals/${referralId}/mark_as_redeemed`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public redeemReferrals(userId: string): Observable<any> {
    return this.http.post(`${BASEURL}/v3/users/${userId}/redemptions`, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public getUserFollowUpBalance(userId: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/clients/${userId}/balances`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public getOverviewAnalytics(month: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/admin/analytics/overview_platform`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        compare_month: month
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public getOverviewAnalyticsFollowUpQnnaires(month: string): Observable<any> {
    return this.http.get(`${BASEURL}/v3/admin/analytics/overview_follow_up_qnnaires`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      params: {
        compare_month: month
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }


  

  public getCoachBio() : Observable<any> {
    return this.http.get(`${BASEURL}/admin/current_bio`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }

  public updateCoachBio(params: any) : Observable<any> {
    return this.http.patch(`${BASEURL}/admin/current_bio`, {user: params}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).pipe(
      tap((response: any) => {
      })
    )
  }
}